module.exports = __webpack_public_path__ + "files/4a37ad6743d927f8f4c3ab3d5e83027b.png";